import { PluginHook } from '../../../../components/PluginHook';

/** */
const DownloadDialogPluginArea = (props) => <PluginHook {...props} />; // eslint-disable-line react/jsx-props-no-spreading

export default DownloadDialogPluginArea;
